export const GET_ALL_CONTACTS = 'GET_ALL_CONTACTS';
export const CREATE_CONTACT = 'CREATE_CONTACT';
export const DELETE_CONTACT = 'DELETE_CONTACT';
export const REPLY_CONTACT = 'REPLY_CONTACT';